import { render, staticRenderFns } from "./GestionTurnosSemanaWide.vue?vue&type=template&id=24051dbc&scoped=true"
import script from "./GestionTurnosSemanaWide.vue?vue&type=script&lang=js"
export * from "./GestionTurnosSemanaWide.vue?vue&type=script&lang=js"
import style0 from "./GestionTurnosSemanaWide.vue?vue&type=style&index=0&id=24051dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24051dbc",
  null
  
)

export default component.exports